// extracted by mini-css-extract-plugin
export var conversationListItem = "_x4-2";
export var fullBleedList = "_x4-3";
export var messageText = "_x4-1";
export var previewText = "_x4-0";